<template lang="pug">
  #modalProductComponent
    transition(name='modal' @click.prevent.self='')
      .modal-mask(v-if='product')
        .modal-wrapper
          .modal-container
            slot
            .productDesc
              .media
                img(:src='product.image_url || imageDefault' alt='' onerror="this.src = '../assets/images/default.png'")
              .name
                h3 {{product.name}}
                p sku: {{product.store_item_id}}
            .productOptions
              .group(v-if='product.childs')
                .optionGroupName
                  h3 Size
                .optionItems
                  .item(v-for='size in product.childs' v-if="size.status !== 'DEACTIVE'")
                    input(type='radio' :id='size.store_item_id' :value='size.store_item_id' v-model='orderItem.Item_Id' v-on:change='selectProduct(size)')
                    label(:for='size.store_item_id')
                      | {{size.name}}
                      span(v-if='size.ta_price') ({{ size.ta_price | formatPrice }})

              .group(v-if='orderItem.options' v-for='(productOption,index) in orderItem.options')
                Customization(
                  :item='productOption'
                  :update='false'
                  :min='productOption.min_permitted'
                  :max='productOption.max_permitted'
                  @change='changeOption(index,...arguments)')

            .productNote
              .inner
                img(src='../assets/images/pen.png' alt='')
                input(placeholder='Add a note for this item' v-model='orderItem.Note')
            .productAddToCart
              .quantity
                span.btn-quantity.minus(v-on:click='minusQuantity')
                span.number {{orderItem.Quantity}}
                span.btn-quantity.plus(v-on:click='plusQuantity')
              .btnAdd(v-on:click='updateCart')
                span Add To Cart
                span.price
                  i.fa.fa-shopping-bag(aria-hidden='true')
                  | +{{(orderItem.Price + orderItem.plusPrice) | formatPrice}}

</template>

<script>

import Customization from "./partials/Customization";

function initialState () {
  return {
    orderItem: {
      Item_Type_Id: "",
      Item_Id: "",
      Item_Name: "",
      Price: 0,
      Quantity: 1,
      Note: "",
      Discount: 0,
      Foc: 0,
      Package_Id: "",
      Fix: 0,
      options: [],
      plusPrice: 0
    },

  }
}

export default {
  name: 'ModalProduct',
  components: {
    Customization,
  },
  props: ['product', 'active', 'activeId', 'order','test'],
  data() {
    return initialState();
  },
  created() {
    // cập nhập
    this.imageDefault = this.$foodbookConfig.imageDefault;
    if (this.order) {
      this.$set(this,'orderItem',this.order)

    }
    // tạo mới
    else {
      let {
        name,
        customizations:options,
        ta_price,
        store_item_id,
      } = this.product
      this.orderItem = {
          Item_Type_Id: "",
          Item_Id: store_item_id,
          Item_Name: name,
          Price: ta_price,
          Quantity: 1,
          Note: "",
          Discount: 0,
          Foc: 0,
          Package_Id: "",
          Fix: 0,
          options,
          plusPrice: 0
      }
    }

  },
  methods: {
    reset: function (){
      Object.assign(this.$data, initialState());
    },

    closeModal(event) {
      if (event.target === event.currentTarget) this.$emit('close')
    },
    minusQuantity() {
      if (this.orderItem.Quantity > 1) this.orderItem.Quantity--;
    },
    plusQuantity() {
      this.orderItem.Quantity++;
    },
    changeOption(index, options, update = false) {
      this.calculate(this.orderItem.options)
    },
    calculate(data) {

      if (data) {
        let exAmount = 0;
        _.forEach(data, prop => {

          if (prop && prop.options)
            prop.options.each(opt => {
              if (opt.quantity && opt.ta_price) exAmount += opt.quantity * opt.ta_price
            })
        })
        this.orderItem.plusPrice = exAmount
      }

    },

    selectProduct(product) {
      this.orderItem.Item_Name = product.name;
      this.orderItem.Price = product.ta_price;
    },

    updateCart() {
      //Check require option
      let error = false;
      _.forEach(this.orderItem.options, (value, key) => {
        if (value.min_permitted) {
          if (value.options.length < value.min_permitted) {
            error = true;
            this.$toasted.show("Please choose " + value.name, {
              position: "top-center",
              duration: 5000,
              type: 'error'
            });
          }
        }
        if (value.max_permitted) {
          if (value.max_permitted === 1 && value.max_permitted === 1)  {
            if (value.options) {
              let c = _.sumBy(value.options,'quantity')
              if (c !==1) {
                error = true;
                this.$toasted.show("Please choose an option! " + value.name, {
                  position: "top-center",
                  duration: 5000,
                  type: 'error'
                });
              }
            }
          } else {
            if (value.options.length > value.max_permitted) {
              error = true;
              this.$toasted.show("You choose too much " + value.name, {
                position: "top-center",
                duration: 5000,
                type: 'error'
              });
            }
          }

        }
      });
      //Check size require
      if (this.product.childs) {
        if (this.orderItem.Item_Id === this.product.store_item_id) {
          error = true;
          this.$toasted.show("Please select a product type (size)", {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
        }
      }
      if (!error) {

        this.$emit('updateCart', this.orderItem, this.product, this.activeId);
      }

    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/ModalProduct.vue